import { defineStore } from 'pinia';
import { useToggle } from '@/composables/useToggle';
import { useState } from '@/composables/common/useState';

export const usePdfStore = defineStore('PDF', () => {
  const [pdfModal, togglePdfModal] = useToggle(false);
  const [src, setSrc] = useState<string | null>(null);
  const [fileName, setFileName] = useState<string>('PDF');

  const openPreview = (src: string, fileName: string) => {
    setSrc(src);
    setFileName(fileName);
    togglePdfModal(true);
  };

  const closePreview = () => {
    setSrc(null);
    setFileName('PDF');
    togglePdfModal(false);
  };

  return {
    src,
    fileName,
    pdfModal,

    togglePdfModal,
    openPreview,
    closePreview,
  };
});
